import { Avatar, Dropdown, Flex, Layout, Tooltip, type MenuProps } from 'antd';
import { Fragment, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings, Key, LogOut, Menu } from 'lucide-react';
import Logo from 'src/assets/images/logo.png';
import Icon from 'src/components/v2/Icon';
import CGButton from 'src/components/CG/Button/CGButton';
import urlPath from 'src/constants/urlPath/urlPath';
import { AppContext } from 'src/contexts/app.context';
import ChangePassword from 'src/pages/Config/ChangePassword';
import Config from 'src/pages/v2/Config/Setting';
import styles from './Header.module.scss';
import Notification from './Notification';
import AdaptiveHorizontalMenu from '../HorizontalMenu/AdaptiveHorizontalMenu';

const { Header: HeaderAntd } = Layout;

const Header = () => {
  const navigate = useNavigate();
  const [openChangePassword, setOpenChangePassword] = useState<boolean>(false);
  const [openConfig, setOpenConfig] = useState<boolean>(false);
  const { setIsSidebarCollapsed, isSidebarCollapsed } = useContext(AppContext);

  const { userInfo } = useContext(AppContext);
  const items: MenuProps['items'] = [
    {
      key: '2',
      onClick: () => setOpenConfig(true),
      label: (
        <div className={styles['header__act-auth-item']}>
          <Settings size={16} color='#64748b' />
          <span>Cài đặt</span>
        </div>
      )
    },
    {
      key: '3',
      onClick: () => {
        handleChangePassword();
      },
      label: (
        <div className={styles['header__act-auth-item']}>
          <Key size={16} color='#64748b' />
          <span>Thay đổi mật khẩu</span>
        </div>
      )
    },
    {
      key: '4',
      onClick: () => {
        handleLogout();
      },
      label: (
        <div className={styles['header__act-auth-item']}>
          <LogOut size={16} color='#64748b' />
          <span>Đăng xuất</span>
        </div>
      )
    }
  ];

  const handleChangePassword = () => {
    setOpenChangePassword(true);
  };
  const handleLogout = async () => {
    const returnUrl = window.location.pathname;
    localStorage.setItem('returnUrl', returnUrl);
    navigate(urlPath.signoutOidc.location);
  };

  const handleToggleSidebar = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };

  const formatNameLetter = (fullName: string | undefined) => {
    if (!fullName) return '';

    return fullName[0].toUpperCase();
  };
  return (
    <Fragment>
      <HeaderAntd className={styles.header}>
        <div className={styles.header__brand}>
          <Icon className={styles['header__brand-logo']} url={Logo} size={40} onClick={() => navigate('/')} />
          <span className={styles['header__brand-title']}>Martech Company</span>
          <Tooltip title={isSidebarCollapsed ? 'Mở menu' : 'Đóng menu'}>
            <CGButton
              type='text'
              size='small'
              shape='default'
              className={styles['header__menu-toggle']}
              onClick={handleToggleSidebar}
              icon={<Menu size={20} />}
              style={{
                padding: '8px',
                minWidth: 'auto',
                height: 'auto'
              }}
            />
          </Tooltip>
        </div>
        {/* Center the menu */}
        <div className={styles['header__center-menu']}>
          <AdaptiveHorizontalMenu maxVisibleItems={3} />
        </div>
        <Flex gap={30} align='center'>
          <Notification />
          <Dropdown menu={{ items }} trigger={['click']} arrow={false}>
            <div className={styles['header__act-auth']}>
              <div className={styles['header__act-auth-left']}>
                {/* <Icon url={User} size={16} /> */}
                <Avatar size={32} className={styles['header__act-auth-avatar']}>
                  {formatNameLetter(userInfo?.fullName)}
                </Avatar>
                <span className={styles['header__act-auth-name']}>{userInfo?.fullName}</span>
              </div>
            </div>
          </Dropdown>
        </Flex>
      </HeaderAntd>

      <ChangePassword open={openChangePassword} setOpen={setOpenChangePassword} />
      <Config open={openConfig} setOpen={setOpenConfig} />
    </Fragment>
  );
};

export default Header;
